import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-creative-native-offer-preview",
  templateUrl: "./creative-native-offer-preview.component.html",
  styleUrl: "./creative-native-offer-preview.component.scss",
})
export class CreativeNativeOfferPreviewComponent implements OnInit {

  @Input() stepInput: any;

  adType: string;
  nativeOfferDetails;
  previewNativeImg;

  constructor() {}

  ngOnInit() {
    this.adType = this.stepInput.adType;
    this.nativeOfferDetails = this.stepInput.nativeOfferDetails;
    this.previewNativeImg = this.stepInput.previewNativeImg;
  }
}
